import NoData from "../../assets/img/nodata_green.svg";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { useEffect, useState } from "react";
import { formatDate } from "../../helpers/commons";
import {
  selectAccessToken,
  selectNtumaAccount,
  selectActiveEnvironment,
} from "../../features/auth/authSlice";
import AppSpinner from "../elements/AppSpinner";
import PinInputOne from "../elements/PinInputOne";
import {
  APP_STATUS,
  ACTIVE_ENV,
  BASE_URL,
  SETTLEMENT_STATUS,
  getNTUMACharge,
  NTUMA_TO_NTUMA_CHARGE,
} from "../../helpers/constants";
import {
  fetchSettlements,
  resetCursorSettlements,
  selectSettlements,
} from "../../features/transactions/settlementsSlice";
import MoneyInput from "../elements/MoneyInput";
import AppButton from "../elements/AppButton";
import { showToastMessage } from "../../features/generalSlice";
import { toast } from "react-toastify";
import useApiRequest from "../../helpers/api_request";
import { AxiosError } from "axios";
import { Console } from "console";
const SettlementsPage = () => {
  const dispatch = useAppDispatch();
  const settlements = useAppSelector(selectSettlements);
  const ntumaAccount = useAppSelector(selectNtumaAccount);
  const loadingSettlementsStatus = useAppSelector(
    (state) => state.settlements.loadingSettlementsStatus
  );
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = useAppSelector((state) => state.settlements.totalPages);
  const [requestModalOpen, setRequestModalOpen] = useState(false);

  useEffect(() => {
    dispatch(resetCursorSettlements());
    dispatch(fetchSettlements());
  }, [ntumaAccount]);

  //new

  const [downloadingCollections, setDownloadingCollections] = useState(false);
  const apiRequest = useApiRequest();
  const accessToken = useAppSelector(selectAccessToken);

  const today = ''

  const [startDate, setStartDate] = useState(today)
  const [endDate, setEndDate] = useState(today)
  const [downloading, setDownloading] = useState(false)

  const handleDownload = () => {
  
    downloadCollections(startDate, endDate)
  }

  
 // const downloadCollections = () => {
    const downloadCollections = (start: string, end: string) => {

    
    if (start && end) {
      const startTime = new Date(start).getTime()
      const endTime = new Date(end).getTime()

      if (startTime > endTime) {
        toast.error("'Start Date' cannot be less greater than the 'End Date'.")
        return
      }
    }

      const toastLoader = toast.loading('Downloading....');

   

    apiRequest({
      method: "get",
    //  url: BASE_URL + "/api/collections/smt_download",
      url:
        BASE_URL +
        '/api/collections/smt_download?startDate=' +
        start +
        '&endDate=' +
        end,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      responseType: "blob",
    })
      .then((res) => {
        
      toast.dismiss(toastLoader);
        const url = URL.createObjectURL(
          new Blob([res], {
            type: "application/vnd.ms-excel",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Ntumas-Settlements.xlsx");
        document.body.appendChild(link);
        link.click();
        setDownloadingCollections(false);
      })
      .catch((error) => {
         toast.dismiss(toastLoader);
        console.log("DATAS-Download:" + JSON.stringify(error));
        const errorResponse = error as AxiosError;
        console.log("DATAS2-Download:" + JSON.stringify(errorResponse));
        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setDownloadingCollections(false);
      });
  };

  return (
    <div>
      <div className="card mb-12">
        <div className="card-body flex flex-col px-4 py-4 min-h-half-screen pb-16">
          <div className="flex">
            <nav className="flex justify-between " aria-label="Breadcrumb">
              <ol className="inline-flex items-center mb-3 sm:mb-0">
                <li>
                  <div className="flex items-center">
                    <h5 className="card-title">Transfers</h5>
                  </div>
                </li>
              </ol>
            </nav>
            <div className="flex-grow flex justify-end">

              {/*
              <DownloadButton
                callBack={() => downloadCollections()}
                isLoading={downloadingCollections}
              />
              */}
              
              <div className='flex items-center gap-1'>
                <div className='w-16 leading-4'>
                  <span className='text-gray-600 text-[13px]'>
                    Download<br/> From:
                  </span>
                </div>
                <input
                  type='date'
                  value={startDate}
                  onChange={e => setStartDate(e.target.value)}
                  className='border border-gray-300 py-1 px-2 h-10 rounded text-gray-500 text-sm focus:outline-none -mt-1'
                />

                <span className='text-gray-600 text-sm -mt-1'>To:</span>

                <input
                  type='date'
                  value={endDate}
                  onChange={e => setEndDate(e.target.value)}
                  className='border border-gray-300 py-1 px-2 h-10 rounded text-gray-500 text-sm focus:outline-none -mt-1'
                />

                <DownloadButton
                  callBack={handleDownload}
                  isLoading={downloading}
                />
              </div>
              &nbsp;&nbsp;&nbsp;
              <button
                onClick={
                  () => setRequestModalOpen(true)
                  //  setCashTransfersModal(true)
                }
                type="button"
                className="prim-btn-1 mb-2"
              >
                Transfers
              </button>
            </div>
          </div>

          {settlements.length === 0 &&
            loadingSettlementsStatus != APP_STATUS.PENDING && (
              <div className=" h-fit flex-grow flex flex-col justify-center ">
                <div className="flex justify-center">
                  <div>
                    <img className=" w-32" src={NoData} alt="" />
                    <p>No Settlements Yet!</p>
                  </div>
                </div>
              </div>
            )}
          {settlements.length > 0 && (
            <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
              <thead>
                <tr>
                  <th scope="col">Date</th>
                  <th scope="col">Amount</th>

                  <th scope="col">Created</th>
                  <th scope="col">Reason</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {settlements.map((item, key) => (
                  <tr key={key}>
                    <td> {formatDate(item.created_at, "MMM DD, YYYY H:mm")}</td>
                    <td>{item.amount.toLocaleString()}</td>

                    <td>
                      {item.creator.firstname} {item.creator.lastname}
                    </td>
                    <td dangerouslySetInnerHTML={{ __html: item.reason }} />

                    <td>
                      {item.status === SETTLEMENT_STATUS.SUCCESSFUL && (
                        <span className="badge-success">{item.status}</span>
                      )}
                      {item.status === SETTLEMENT_STATUS.REJECTED && (
                        <span className="badge-failed">{item.status}</span>
                      )}
                      {item.status === SETTLEMENT_STATUS.PENDING && (
                        <span className="badge-pending">{item.status}</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}

          {loadingSettlementsStatus === APP_STATUS.PENDING && <AppSpinner />}
          {currentPage < totalPages && (
            <div className=" flex justify-center mt-16">
              <button
                onClick={() => {
                  setCurrentPage(currentPage + 1);
                  dispatch(fetchSettlements());
                }}
                type="button"
                className="btn-light text-gray-600 "
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  className=" text-gray-600"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M14 16h5v5M10 8H5V3m14.418 6.003A8 8 0 0 0 5.086 7.976m-.504 7.021a8 8 0 0 0 14.331 1.027"
                  />
                </svg>
                <span className="pl-1">Load More</span>
              </button>
            </div>
          )}
        </div>
      </div>
      <SettlementModal
        settlemtSaved={() => {
          dispatch(resetCursorSettlements());
          dispatch(fetchSettlements());
        }}
        isOpen={requestModalOpen}
        onClose={() => setRequestModalOpen(false)}
      />
    </div>
  );
};
export default SettlementsPage;

type TypeSettlementModalProps = {
  isOpen: boolean;
  onClose: () => void;
  settlemtSaved: () => void;
};

const SettlementModal = (props: TypeSettlementModalProps) => {
  const ntumaAccount = useAppSelector(selectNtumaAccount);
  const activeEnvironment = useAppSelector(selectActiveEnvironment);

  let walletBalance = 0;

  /*if (ntumaAccount?.userWallet) {
    walletBalance = ntumaAccount?.userWallet?.current_balance;
  }*/
  if (ntumaAccount?.userWallet) {
    walletBalance =
      activeEnvironment === ACTIVE_ENV.test
        ? ntumaAccount?.userWallet?.current_balance_sand_box
        : ntumaAccount?.userWallet?.current_balance;
  }

  const [amount, setAmount] = useState(0);
  const [reason, setReason] = useState("");
  const [receiverNtumaAccount, setReceiverNtumaAccount] = useState("");

  const [isRequestingSettlement, setIsRequestingSettlement] = useState(false);
  const dispatch = useAppDispatch();
  const apiRequest = useApiRequest();
  const accessToken = useAppSelector(selectAccessToken);

  const [showCreatePinModal, setShowCreatePinModal] = useState(false);

  const [showWalletTransferModal, setShowWalletTransferModal] = useState(false);

  const [showEnterPINModal, setEnterPINModal] = useState(false);
  const [walletPin, setWalletPin] = useState("");
  const [newWalletPin, setNewWalletPin] = useState("");
  const [pinTouched, setPinTouched] = useState(false);

  const [selectedOption, setSelectedOption] = useState("sendrequest");

  const [phone_number, setPhoneNumber] = useState("");
  const [phoneTouched, setPhoneTouched] = useState(false);

  const [account_name, setAccountName] = useState("");
  const [rc_ntuma_account_id, setReceiverNtumaAccountId] = useState(0);
  const [rc_creator_id, setReceiverNtumaCreatorId] = useState(0);
  const [transfer_charge, setWalletTransferCharge] = useState(0);
  const [service_type, setServiceType] = useState("");

  const [rc_user_id, setReceiverUserId] = useState(0);

  //------------------- nee code ----------------------

  const [currentOption, setCurrentOption] = useState("");

  //dynamic fields
  const userId = ntumaAccount?.user_id;
  const creatorId = ntumaAccount?.user_id;
  const ntumaAccountId = ntumaAccount?.id;

  const handleSelectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedOption(event.target.value);
  };

  // Function to handle PIN value from PinInput
  const handlePinChange = (newPin: string) => {
    setWalletPin(newPin); // Update the walletPin state with the new value
  };
  const handleClose = () => {
    setWalletPin("");
    setNewWalletPin("");
    setPinTouched(false);
    props.onClose();
    setEnterPINModal(false);
    setShowCreatePinModal(false);
  };

  useEffect(() => {
    dispatch(checkWalletPin);
  }, []);

  const createWalletPin = async () => {
    setIsRequestingSettlement(true);
    try {
      const response = await apiRequest({
        method: "post",
        url: BASE_URL + "/api/wallet/set_pin",
        headers: { "Content-Type": "application/json" },
        data: {
          /*user_id: userId,
          pin: newWalletPin,*/
          user_id: userId,
          ntuma_account_id: ntumaAccountId,
          active_environment: activeEnvironment,
          pin: newWalletPin,
        },
      });
      setIsRequestingSettlement(false);

      if (response.status === "SUCCESS") {
        setShowCreatePinModal(false);
        dispatch(
          showToastMessage({
            message: "" + response.message,
            type: "success",
            position: toast.POSITION.TOP_RIGHT,
          })
        );
      } else {
        setShowCreatePinModal(true);
        dispatch(
          showToastMessage({
            message: "" + response.message,
            type: "error",
            position: toast.POSITION.TOP_RIGHT,
          })
        );
      }
    } catch (error) {
      toast.error("Failed to check wallet PIN.");
      setIsRequestingSettlement(false);
    }
  };

  const checkWalletPin = async () => {
    setShowCreatePinModal(false);

    try {
      const response = await apiRequest({
        method: "post",
        url: BASE_URL + "/api/wallet/pin_exists",
        headers: { "Content-Type": "application/json" },
        data: {
          ntuma_account_id: ntumaAccountId,
        },
      });

      if (response.status === "SUCCESS") {
        props.onClose();
        setEnterPINModal(false);
        setShowCreatePinModal(false);
        setShowWalletTransferModal(true);
      } else {
        setShowCreatePinModal(true); // Keep modal open if verification fails
      }
    } catch (error) {
      setShowCreatePinModal(true);
    }
  };

  //Ntuma-Ntuma wallet transfers
  const Wallet2WalletTransfer = async () => {
    props.onClose();

    const current_env = activeEnvironment === ACTIVE_ENV.test ? "test" : "prod";

    if (amount === 0 || amount > walletBalance) {
      dispatch(
        showToastMessage({
          message: "Invalid Amount",
          type: "error",
          position: toast.POSITION.TOP_CENTER,
        })
      );
      return;
    }
    setIsRequestingSettlement(true);

    const toastLoader = toast.loading("Processing");

    try {
      const response = await apiRequest({
        method: "post",
        url: BASE_URL + "/api/wallet-transfers/p2p",
        headers: { "Content-Type": "application/json" },
        data: {
          senderAccountId: ntumaAccountId,
          recipientAccountId: rc_ntuma_account_id,
          creatorId: rc_creator_id,
          amount: Number(amount),
          reason: reason,
          env: current_env,
        },
      });
      toast.dismiss(toastLoader);
      if (response.success) {
        dispatch(
          showToastMessage({
            message: "" + response.message,
            type: "success",
            position: toast.POSITION.TOP_RIGHT,
          })
        );

        setIsRequestingSettlement(false);
        props.settlemtSaved();
        props.onClose();
      } else {
        toast.dismiss(toastLoader);
        toast.error("" + response.message);
      }
    } catch (error) {
      toast.dismiss(toastLoader);
      toast.error("An error occured");
    }
  };

  const doWallet2WalletTransfer = async () => {
    const toastLoader = toast.loading("Processing");
    setIsRequestingSettlement(true);

    try {
      const response = await apiRequest({
        method: "post",
        url: BASE_URL + "/api/wallet/verify_ntuma_acc_number",
        headers: { "Content-Type": "application/json" },
        data: {
          ntuma_account_number: receiverNtumaAccount,
          sender_ntuma_account_id: ntumaAccountId
        },
      });

      toast.dismiss(toastLoader);
      setIsRequestingSettlement(false);

      if (response.status === "SUCCESS") {
        const thisAccountNtumaId = response.ntuma_account_id;

        //getNtumaAccountByThatID

        const responseAccount = await apiRequest({
          method: "post",
          url: BASE_URL + "/api/wallet/user_with_ntuma",
          headers: { "Content-Type": "application/json" },
          data: {
            ntuma_account_id: thisAccountNtumaId,
          },
        });
        console.log("DATAS RESP" + JSON.stringify(responseAccount));


        if (responseAccount.status === "SUCCESS") {
          //let rc_userId = responseAccount.data.user_id;
          let rc_ntumaAccountId = responseAccount.data.ntuma_account_id;

          //Console.log("DATAS");

          //if (rc_userId !== userId) {
          if (rc_ntumaAccountId !== ntumaAccountId) {
            const firstNtumaAccount = responseAccount.data;

            if (firstNtumaAccount != null) {
              setAccountName(firstNtumaAccount.account_name);
              setWalletTransferCharge(NTUMA_TO_NTUMA_CHARGE);

              setReceiverNtumaAccountId(firstNtumaAccount.ntuma_account_id);

              setReceiverUserId(firstNtumaAccount.user_id);

              setReceiverNtumaCreatorId(firstNtumaAccount.user_id);

              setEnterPINModal(true);
              props.onClose();
            } else {
              toast.error("No Ntuma account(s) found!");
            }
          } else {
            toast.error("You can not transfer to the same account!");
          }
        } else {
          toast.error(responseAccount.message || "An error occurred.");
        }
      } else {
        toast.error(response.message || "An error occurred.");
      }
    } catch (error) {
      toast.dismiss(toastLoader);
      setIsRequestingSettlement(false);
    }
  };

  const doSendSettlementRequest = async () => {
    setIsRequestingSettlement(true);
    await apiRequest({
      method: "post",
      url: BASE_URL + "/api/settlements/create",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
      data: {
        amount: amount,
        reason: reason,
      },
    })
      .then((response) => {
        setIsRequestingSettlement(false);
        dispatch(
          showToastMessage({
            message: "Request Sent",
            type: "success",
            position: toast.POSITION.TOP_RIGHT,
          })
        );
        props.settlemtSaved();
        props.onClose();
      })
      .catch((error) => {
        const errorResponse = error as AxiosError;

        if (errorResponse.response) {
          const data = errorResponse.response.data as {
            message: string;
            status: string;
          };
          dispatch(
            showToastMessage({
              message: data.message,
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        } else {
          dispatch(
            showToastMessage({
              message: "Something went wrong",
              type: "error",
              position: toast.POSITION.TOP_RIGHT,
            })
          );
        }
        setIsRequestingSettlement(false);
      });
  };

  //TODO Yo-Payouts

  const WalletToMobileMoney = async () => {
    props.onClose();

    const current_env =
      activeEnvironment === ACTIVE_ENV.test ? "test" : "production";

    if (amount === 0 || amount > walletBalance) {
      dispatch(
        showToastMessage({
          message: "Invalid Amount",
          type: "error",
          position: toast.POSITION.TOP_CENTER,
        })
      );
      return;
    }
    if (amount < 5000 || amount > 5000000) {
      dispatch(
        showToastMessage({
          message: "Invalid Amount- Minimum 5,000 and Maximum 5,000,000",
          type: "error",
          position: toast.POSITION.TOP_CENTER,
        })
      );
      return;
    }
    setIsRequestingSettlement(true);

    const toastLoader = toast.loading("Processing");

    try {
      const response = await apiRequest({
        method: "post",
       
        url: BASE_URL + "/api/yo-withdraw",
        headers: { "Content-Type": "application/json" },
        data: {
          active_env: current_env,
          creator_id: userId,
          ntuma_account_id: ntumaAccount?.id,
          name: "Payout request for "+ntumaAccount?.account_name,
          description: reason,
          groupText: "Processed by NTUMA Payments for: "+ntumaAccount?.account_name,

          beneficiaries: [
            {
              amount: amount,
              account_number: phone_number,
              account_type: "MOBILE MONEY",
              narration: reason,
            },
          ],
        },
      });
      console.log("Response" + JSON.stringify(response));
      toast.dismiss(toastLoader);
      if (response.status === "SUCCESS") {
        dispatch(
          showToastMessage({
            message: "" + response.message,
            type: "success",
            position: toast.POSITION.TOP_RIGHT,
          })
        );

        setIsRequestingSettlement(false);
        props.settlemtSaved();
        props.onClose();
      } else {
        toast.dismiss(toastLoader);
        toast.error("" + response.message);
      }
    } catch (error) {
      toast.dismiss(toastLoader);
      toast.error("An error occured");
    }
  };

  const doWalletToMobileMoney = async () => {
    //TODO verify, then make payout, we already have another or reuse one on success show PIN Model

    //  setIsRequestingSettlement(true);

    if (amount === 0 || amount > walletBalance) {
      dispatch(
        showToastMessage({
          message: "Invalid Amount",
          type: "error",
          position: toast.POSITION.TOP_CENTER,
        })
      );
      return;
    }

    if (amount < 5000) {
      dispatch(
        showToastMessage({
          message: "Enter amount greater than UGX 10,000",
          type: "error",
          position: toast.POSITION.TOP_CENTER,
        })
      );
      return;
    }

    const toastLoader = toast.loading("Processing");

    const current_env =
      activeEnvironment === ACTIVE_ENV.test ? "test" : "production";
    
    try {
      const response = await apiRequest({
        method: "post",
        // url: BASE_URL + "/api/yo/process_payout",
        url: BASE_URL +"/api/yo-verify_phone",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          account: phone_number,
          amount: amount, 
          activeEnv: current_env,
          ntumaAccountId: ntumaAccount?.id,
        },
      });
      toast.dismiss(toastLoader);
      setIsRequestingSettlement(false);

      if (response.status === "SUCCESS") {
        dispatch(
          showToastMessage({
            message: response.message,
            type: "success",
            position: toast.POSITION.TOP_RIGHT,
          })
        );

        console.log(
          "Verify phone number, return charges and name" +
            JSON.stringify(response)
        );

        setAccountName(response.details.fullName);

        const charge = getNTUMACharge(amount);

        setWalletTransferCharge(charge);

        setReceiverNtumaAccountId(ntumaAccount?.id!);

        setReceiverNtumaAccount(phone_number);

        setReceiverUserId(ntumaAccount?.user_id!);

        setReceiverNtumaCreatorId(ntumaAccount?.id!);

        setEnterPINModal(true);
        props.onClose();
      } else {
        dispatch(
          showToastMessage({
            message: response.message || "Transaction Failed!",
            type: "error",
            position: toast.POSITION.TOP_RIGHT,
          })
        );
        return false;
      }
    } catch (error) {
      toast.dismiss(toastLoader);
      const errorResponse = error as AxiosError;

      if (errorResponse.response) {
        const data = errorResponse.response.data as {
          message: string;
          status: string;
        };
        dispatch(
          showToastMessage({
            message: data.message,
            type: "error",
            position: toast.POSITION.TOP_RIGHT,
          })
        );
      } else {
        dispatch(
          showToastMessage({
            message: "Something went wrong",
            type: "error",
            position: toast.POSITION.TOP_RIGHT,
          })
        );
      }
      setIsRequestingSettlement(false);
      return false;
    }
  };

  const sendRequest = async () => {
    if (amount === 0 || amount > walletBalance) {
      dispatch(
        showToastMessage({
          message: "Invalid Amount",
          type: "error",
          position: toast.POSITION.TOP_CENTER,
        })
      );
      return;
    }

    switch (selectedOption) {
      case "wallet_transfer":
        doWallet2WalletTransfer();
        setServiceType("INTER-ACCOUNT TRANSFERS");
        break;

      case "sendrequest":
        doSendSettlementRequest();
        setServiceType("SETTLEMENT REQUEST");
        break;

      case "mobilemoney":
        doWalletToMobileMoney();
        setServiceType("MOBILE MONEY TRANSFERS");
        break;

      default:
        toast.error("Select an option for payout");
        break;
    }
  };

  const options = [
    { value: "sendrequest", label: "Request Withdraw" },
    { value: "wallet_transfer", label: "Send to Ntuma Customer" },
  ];

  useEffect(() => {
    
    setPhoneTouched(false)
    setPhoneNumber('')
  }, [selectedOption])

  interface Beneficiary {
    id: string
    account_identifier: string
    account_names: string
    service_type: string
    created_at?: string
    updated_at?: string
  }

  const [beneficiaries, setBeneficiaries] = useState([])
  const [showSuggestions, setShowSuggestions] = useState(false)
  //const [isButtonEnabled, setIsButtonEnabled] = useState(false)


  const fetchBeneficiaries = async () => {
      if (!ntumaAccount || !ntumaAccount.id) {
        return
      }
      setIsRequestingSettlement(true)

      try {
        const response = await apiRequest({
          method: 'post',
          url: BASE_URL + '/api/wallet/get_beneficiaries',
          headers: { 'Content-Type': 'application/json' },
          data: {
            service_type: 'MOBILE_MONEY',
            ntuma_account_id: ntumaAccount?.id
          }
        })
        setIsRequestingSettlement(false)
        console.log('DATAS-23' + JSON.stringify(response.data))

        if (response.success) {
          //  setShowCreatePinModal(false);
          setBeneficiaries(response.data)

         
        } else {
          //  setShowCreatePinModal(true);
        /*  dispatch(
            showToastMessage({
              message: '' + response.message,
              type: 'error',
              position: toast.POSITION.TOP_RIGHT
            })
          )*/
        }
      } catch (error) {
        toast.error('Failed to check wallet PIN.')
        setIsRequestingSettlement(false)
      }
    }


  useEffect(() => {
    fetchBeneficiaries()
  }, [ntumaAccount])



  return (
    <>
      {/*
        (props.isOpen) &&
        <div className="modal ">
          <div className=" modal-content modal-md py-4">
            <div className=" flex justify-center">
              <span className="text-center text-lg">Request Withdraw</span>
            </div>

            <div className=" mt-4">
              <label htmlFor="" className="block text-sm font-medium text-gray-700 ">Wallet</label>
              <select name="" className="form-input-2" id="">
                <option value="Fixed Charge">{ntumaAccount?.userWallet?.current_balance.toLocaleString()}</option>
              </select>
            </div>
            <div className="mt-4">
              <label htmlFor="amount" className="block text-sm font-medium text-gray-700 ">Amount</label>
              <MoneyInput value={amount} onChange={(value) => setAmount(value)} className="form-input-2" />
            </div>
            {
              (amount > walletBalance) &&
              <span className=" text-red-600">Invalid Amount</span>
            }
            <div className="mt-4">
              <label htmlFor="reason" className="block text-sm font-medium text-gray-700 ">Reason</label>
              <input value={reason} type="text" onChange={(e) => setReason(e.target.value)} placeholder="Enter reason for settlement" className="form-input-2" />
            </div>
            <div className="flex flex-row-reverse mt-10 pt-4 px-0  gap-2">
              <div>
                <AppButton callBackFun={() => sendRequest()} showLoader={isRequestingSettlement} spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black" className="prim-btn-2  " text="Send Request" />
              </div>
              <div>
                <button onClick={() => props.onClose()} type="button" className="btn-secondary-1 ">Close</button>
              </div>
            </div>
          </div>
        </div>
        */}

      {
        /* Show create PIN*/

        showCreatePinModal && (
          <div className="modal">
            <div className="modal-content modal-md py-4">
              <label
                htmlFor="newWalletPin"
                className="block text-sm font-medium text-gray-700"
              >
                Create a wallet PIN
              </label>

              <PinInputOne
                className="form-input-2"
                getValue={setNewWalletPin}
              />

              <div className="flex flex-row-reverse mt-10 pt-4 px-0 gap-2">
                <div>
                  <AppButton
                    callBackFun={() => {
                      createWalletPin();
                    }}
                    showLoader={isRequestingSettlement}
                    spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black"
                    className="prim-btn-2"
                    text="Create Wallet PIN"
                  />
                </div>
                <div>
                  <button
                    onClick={() => {
                      props.onClose();
                      setShowCreatePinModal(false);
                    }}
                    type="button"
                    className="btn-secondary-1"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {
        /* Show Money transfers*/
        props.isOpen && (
          <div className="modal ">
            <div className=" modal-content modal-md py-4">
              <div className=" flex justify-center">
                <span className="text-center text-lg">Transfers</span>
              </div>

              <div className=" mt-4">
                <label
                  htmlFor=""
                  className="block text-sm font-medium text-gray-700 "
                >
                  Select transfer option
                </label>
                <select
                  name="transferType"
                  className="form-input-2"
                  onChange={handleSelectChange}
                  value={selectedOption}
                >
                  <option value="sendrequest">Request Transfer</option>
                  <option value="wallet_transfer">
                    Transfer to Ntuma Customer
                  </option>
                  <option value="mobilemoney">Payout via Mobile money</option>
                </select>
              </div>

              <div className=" mt-4">
                <label
                  htmlFor=""
                  className="block text-sm font-medium text-gray-700 "
                >
                  Wallet
                </label>
                <select name="" className="form-input-2" id="">
                  <option value="Fixed Charge">
                    {
                      //ntumaAccount?.userWallet?.current_balance.toLocaleString()
                      ntumaAccount?.userWallet
                        ? (activeEnvironment === ACTIVE_ENV.test
                            ? ntumaAccount?.userWallet?.current_balance_sand_box
                            : ntumaAccount?.userWallet?.current_balance
                          ).toLocaleString()
                        : "0.0"
                    }
                  </option>
                </select>
              </div>

              {/* Show this only if wallet_transfer is selected */}
              {selectedOption === 'wallet_transfer' && (
                <div className='mt-4 relative'>
                  <label
                    htmlFor='receiverNtumaAccount'
                    className='block text-sm font-medium text-gray-700'
                  >
                    Ntuma Account Number
                  </label>
                  <input
                    id='receiverNtumaAccount'
                    value={receiverNtumaAccount}
                    type='text'
                    onChange={e => setReceiverNtumaAccount(e.target.value)}
                    onFocus={() => setShowSuggestions(true)}
                    onBlur={() => {
                      setTimeout(() => setShowSuggestions(false), 150)
                      setPhoneTouched(true) // same touched state as phone
                    }}
                    placeholder='Ntuma Account Number'
                    className='form-input-2 w-full'
                    autoComplete='off'
                  />

                  {/* Validation */}
                  {phoneTouched && !receiverNtumaAccount && (
                    <span className='text-red-600'>
                      Account number cannot be empty
                    </span>
                  )}
                  {phoneTouched &&
                    receiverNtumaAccount &&
                    !/^[0-9]{6,20}$/.test(receiverNtumaAccount) && (
                      <span className='text-red-600'>
                        Invalid account number. Must be 6–20 digits long.
                      </span>
                    )}

                  {/* Auto-suggest */}

                  {showSuggestions &&
                    receiverNtumaAccount &&
                    beneficiaries.length > 0 &&
                    (() => {
                      const filtered = beneficiaries.filter(
                        (b: Beneficiary) =>
                          b.service_type === 'INTERNAL_TRANSFERS' &&
                          b.account_identifier?.startsWith(
                            receiverNtumaAccount.trim()
                          )
                      )
                      if (filtered.length === 0) return null

                      return (
                        <ul className='absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 max-h-48 overflow-y-auto'>
                          {filtered.map((b: Beneficiary) => (
                            <li
                              key={b.id}
                              onMouseDown={() => {
                                setReceiverNtumaAccount(b.account_identifier)
                                setShowSuggestions(false)
                              }}
                              className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                            >
                              <div className='text-sm font-medium'>
                                {b.account_identifier}
                              </div>
                              <div className='text-xs text-gray-500'>
                                {b.account_names}
                              </div>
                            </li>
                          ))}
                        </ul>
                      )
                    })()}
                </div>
              )}

              {/* Show this only if mobilemoney is selected */}
              {selectedOption === 'mobilemoney' && (
                <div className='mt-4 relative'>
                  <label
                    htmlFor='receiverPhone'
                    className='block text-sm font-medium text-gray-700'
                  >
                    Receiver's phone
                  </label>
                  <input
                    id='receiverPhone'
                    value={phone_number}
                    type='tel'
                    onChange={e => setPhoneNumber(e.target.value)}
                    onFocus={() => setShowSuggestions(true)}
                    onBlur={() => {
                      setTimeout(() => setShowSuggestions(false), 150)
                      setPhoneTouched(true)
                    }}
                    placeholder='07..'
                    className='form-input-2 w-full'
                    autoComplete='off'
                  />

                  {/* Validation */}
                  {phoneTouched && !phone_number && (
                    <span className='text-red-600'>
                      Phone number cannot be empty
                    </span>
                  )}
                  {phoneTouched &&
                    phone_number &&
                    !/^[0-9]{10,15}$/.test(phone_number) && (
                      <span className='text-red-600'>
                        Invalid phone number. Must be 10–15 digits long.
                      </span>
                    )}

                  {/* Auto-suggest */}
                  {showSuggestions &&
                    phone_number &&
                    beneficiaries.length > 0 &&
                    (() => {
                      const filtered = beneficiaries.filter(
                        (b: Beneficiary) =>
                          b.service_type === 'MOBILE_MONEY' &&
                          b.account_identifier?.startsWith(phone_number.trim())
                      )
                      if (filtered.length === 0) return null

                      return (
                        <ul className='absolute z-10 w-full bg-white border border-gray-300 rounded-md shadow-md mt-1 max-h-48 overflow-y-auto'>
                          {filtered.map((b: Beneficiary) => (
                            <li
                              key={b.id}
                              onMouseDown={() => {
                                setPhoneNumber(b.account_identifier)
                                setShowSuggestions(false)
                              }}
                              className='px-3 py-2 hover:bg-gray-100 cursor-pointer'
                            >
                              <div className='text-sm font-medium'>
                                {b.account_identifier}
                              </div>
                              <div className='text-xs text-gray-500'>
                                {b.account_names}
                              </div>
                            </li>
                          ))}
                        </ul>
                      )
                    })()}
                </div>
              )}

              <div className="mt-4">
                <label
                  htmlFor="amount"
                  className="block text-sm font-medium text-gray-700 "
                >
                  Amount
                </label>
                <MoneyInput
                  value={amount}
                  onChange={(value) => setAmount(value)}
                  className="form-input-2"
                />
              </div>
              {amount > walletBalance && (
                <span className=" text-red-600">Invalid Amount</span>
              )}
              <div className="mt-4">
                <label
                  htmlFor="reason"
                  className="block text-sm font-medium text-gray-700 "
                >
                  Reason
                </label>
                <input
                  value={reason}
                  type="text"
                  onChange={(e) => setReason(e.target.value)}
                  placeholder="Enter reason"
                  className="form-input-2"
                />
              </div>
              <div className="flex flex-row-reverse mt-10 pt-4 px-0  gap-2">
                <div>
                  <AppButton
                    callBackFun={() => sendRequest()}
                    showLoader={isRequestingSettlement}
                    spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black"
                    className="prim-btn-2  "
                    text="Continue"
                  />
                </div>
                <div>
                  <button
                    onClick={() => props.onClose()}
                    type="button"
                    className="btn-secondary-1 "
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {
        /* Show verify PIN*/

        showEnterPINModal && (
          <div className="modal">
            <div className="modal-content modal-md py-4">
              <label
                htmlFor="newWalletPin"
                className="block text-sm font-medium text-gray-700"
              >
                Authenticate with PIN
              </label>

              <div className="mt-4">
                <div>
                  <hr />
                  <br />
                  <label
                    htmlFor="accountName"
                    className="block text-sm font-medium text-gray-700"
                  >
                    {service_type}
                    <br />
                    <br />
                    Receiver: {account_name} - {receiverNtumaAccount}
                    <br />
                    Amount: {Number(amount).toLocaleString()}
                    <br />
                    Transfer charge: {Number(transfer_charge).toLocaleString()}
                    <br />
                    Reason: {reason}
                    <br />
                  </label>
                  <br />
                  <hr />
                  <br />
                </div>

                <label
                  htmlFor="walletPin"
                  className="block text-sm font-medium text-gray-700"
                >
                  Enter Wallet PIN*
                </label>

                <PinInputOne
                  className="form-input-2"
                  getValue={handlePinChange}
                />

                {/* Validation */}
                {pinTouched && !walletPin && (
                  <span className="text-red-600">
                    Wallet PIN cannot be empty
                  </span>
                )}
                {pinTouched &&
                  walletPin.length > 0 &&
                  walletPin.length !== 5 && (
                    <span className="text-red-600">
                      Wallet PIN must be exactly 5 digits
                    </span>
                  )}
              </div>

              <div className="flex flex-row-reverse mt-10 pt-4 px-0 gap-2">
                <div>
                  <AppButton
                    callBackFun={async () => {
                      setPinTouched(true);

                      if (!walletPin || walletPin.length !== 5) {
                        setWalletPin(walletPin);
                        return;
                      }
                      setIsRequestingSettlement(true);
                      try {
                        const response = await apiRequest({
                          method: "post",
                          url: BASE_URL + "/api/wallet/verify_pin",
                          headers: { "Content-Type": "application/json" },
                          data: {
                            ntuma_account_id: ntumaAccountId,
                            pin: walletPin,
                          },
                        });

                        if (response.status === "SUCCESS") {
                          setEnterPINModal(false);

                          console.log("Option" + selectedOption);
                          if (selectedOption === "wallet_transfer") {
                            Wallet2WalletTransfer();
                          }
                          if (selectedOption === "mobilemoney") {
                            WalletToMobileMoney();
                          }

                          //switch to get the proper select
                          setIsRequestingSettlement(false);
                        } else {
                          dispatch(
                            showToastMessage({
                              message:
                                response.message ||
                                "The provided PIN is invalid. Please ensure it’s correct and try again!",
                              type: "error",
                              position: toast.POSITION.TOP_CENTER,
                            })
                          );
                          setIsRequestingSettlement(false);
                        }
                      } catch (error) {
                        const errorResponse = error as AxiosError;

                        if (errorResponse.response) {
                          const data = errorResponse.response.data as {
                            message: string;
                            status: string;
                          };
                          dispatch(
                            showToastMessage({
                              message:
                                data.message ||
                                "An error occurred while verifying PIN.",
                              type: "error",
                              position: toast.POSITION.TOP_CENTER,
                            })
                          );
                        } else {
                          dispatch(
                            showToastMessage({
                              message:
                                "Something went wrong. Please try again later.",
                              type: "error",
                              position: toast.POSITION.TOP_CENTER,
                            })
                          );
                        }
                        setIsRequestingSettlement(false);
                        return false;
                      }
                    }}
                    className="prim-btn-2"
                    text="Verify"
                    showLoader={isRequestingSettlement}
                    spinnerClass="inline w-3 h-3 mr-2 text-prim-yellow animate-spin fill-black"
                  />
                </div>
                <div>
                  <button
                    onClick={handleClose}
                    type="button"
                    className="btn-secondary-1"
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        )
      }
    </>
  );
};

export const DownloadButton = ({
  isLoading,
  callBack,
}: {
  isLoading: boolean;
  callBack: () => void;
}) => {
  return (
    <>
      <button
        onClick={() => callBack()}
        type="button"
        className=" btn-light mb-2"
      >
        {!isLoading ? (
          <div className=" flex">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              className=" text-gray-600"
              viewBox="0 0 24 24"
            >
              <path
                fill="currentColor"
                d="M6.5 20q-2.275 0-3.887-1.575Q1 16.85 1 14.575q0-1.95 1.175-3.475Q3.35 9.575 5.25 9.15q.425-1.8 2.125-3.425Q9.075 4.1 11 4.1q.825 0 1.413.587Q13 5.275 13 6.1v6.05l.9-.875q.275-.275.688-.275q.412 0 .712.3q.275.275.275.7q0 .425-.275.7l-2.6 2.6q-.15.15-.325.212q-.175.063-.375.063t-.375-.063q-.175-.062-.325-.212l-2.6-2.6q-.275-.275-.287-.688Q8.4 11.6 8.7 11.3q.275-.275.687-.288q.413-.012.713.263l.9.875V6.1q-1.9.35-2.95 1.837Q7 9.425 7 11h-.5q-1.45 0-2.475 1.025Q3 13.05 3 14.5q0 1.45 1.025 2.475Q5.05 18 6.5 18h12q1.05 0 1.775-.725Q21 16.55 21 15.5q0-1.05-.725-1.775Q19.55 13 18.5 13H17v-2q0-1.2-.55-2.238Q15.9 7.725 15 7V4.675q1.85.875 2.925 2.588Q19 8.975 19 11q1.725.2 2.863 1.487Q23 13.775 23 15.5q0 1.875-1.312 3.188Q20.375 20 18.5 20Zm5.5-8.95Z"
              />
            </svg>
            <span className=" pl-[2px] text-gray-600 text-sm">Download</span>
          </div>
        ) : (
          <div className="flex justify-center">
            <div role="status">
              <svg
                aria-hidden="true"
                className="inline w-3 h-3 mr-2 text-gray-100 animate-spin fill-black"
                viewBox="0 0 100 101"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                  fill="currentColor"
                />
                <path
                  d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                  fill="currentFill"
                />
              </svg>
              <span className="sr-only">Loading...</span>
            </div>
            Please wait
          </div>
        )}
      </button>
    </>
  );
};
